/// Menu
import MetisMenu from "metismenujs";
import React, { Component, Fragment, useEffect, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";

import Tooltip from 'react-power-tooltip'

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() {

  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

class SideBar extends Component {
  /// Open menu
  componentDidMount() {
    // sidebar open/close
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");

    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }

    btn.addEventListener("click", toggleFunc);
  }
  state = {
    loveEmoji: false,
  };
  render() {
    const loggedInUser = JSON.parse(localStorage.getItem('user'))
    let path = window.location.pathname;
    path = path.split('/');
    path = path[path.length - 1];

    /// Path
    let Administrator = [
      { sideMenu: "Administrator", url: "statistics", name: "Statistics", icon: 'fa fa-line-chart' },
      { sideMenu: "Administrator", url: "dashboard", name: "Dashboard", icon: 'fa fa-dashboard' },
      { sideMenu: "Administrator", url: "add-job", name: "Add Job", icon: 'fa fa-plus-square' },
      { sideMenu: "Administrator", url: "list-job", name: "List Job", icon: 'fa fa-list' },
      { sideMenu: "Administrator", url: "list-candidate", name: "List Candidate", icon: 'fa fa-users' },
      { sideMenu: "Administrator", url: "list-recruiting-agent", name: "List Recruiting Agents", icon: 'fa fa-list-ul' },
      { sideMenu: "Administrator", url: "create-user", name: "Create Users", icon: 'fa fa-user-plus' },
      { sideMenu: "Administrator", url: "list-user", name: "List Users", icon: 'fa fa-user-secret' },
      { sideMenu: "Administrator", url: "company-master", name: "Company Master", icon: 'fa fa-building' },
      { sideMenu: "Administrator", url: "list-invoice", name: "Invoices", icon: 'fa fa-money' },
      { sideMenu: "Administrator", url: "master-data", name: "Master Data", icon: 'fa fa-database' },
    ],

      RecruitingAgent = (loggedInUser?.agentStatus === 'Unverified' || loggedInUser?.agentStatus === 'Approved') ? [
        { sideMenu: "Recruiting Agent", url: "agent-profile", name: "Agent Profile", icon: 'fa fa-user-circle' }
      ] : [
        { sideMenu: "Recruiting Agent", url: "agent-dashboard", name: "Dashboard", icon: 'fa fa-dashboard' },
        { sideMenu: "Recruiting Agent", url: "list-job", name: "List Job", icon: 'fa fa-list' },
        { sideMenu: "Recruiting Agent", url: "work-list", name: " Work List", icon: 'fa fa-briefcase' },
        { sideMenu: "Recruiting Agent", url: "list-candidate", name: "List Candidate", icon: 'fa fa-users' },

      ],

      InternalTeam = [
        { sideMenu: "Internal Recruiter", url: "dashboard", name: "Dashboard", icon: 'fa fa-dashboard' },
        { sideMenu: "Internal Recruiter", url: "add-job", name: "Add Job", icon: 'fa fa-plus-square' },
        { sideMenu: "Internal Recruiter", url: "list-job", name: "List Job", icon: 'fa fa-list' },
        { sideMenu: "Internal Recruiter", url: "list-candidate", name: "List Candidate", icon: 'fa fa-users' },

        { sideMenu: "Internal Recruiter", url: "master-data", name: "Master Data", icon: 'fa fa-database' },
      ],

      Accountant = [
        { sideMenu: "Accountant", url: "list-invoice", name: "Invoices", icon: 'fa fa-money' },
      ]
    
      let KeyAccountManager = [
        { sideMenu: "Administrator", url: "statistics", name: "Statistics", icon: 'fa fa-line-chart' },
        { sideMenu: "Administrator", url: "dashboard", name: "Dashboard", icon: 'fa fa-dashboard' },
        { sideMenu: "Administrator", url: "add-job", name: "Add Job", icon: 'fa fa-plus-square' },
        { sideMenu: "Administrator", url: "list-job", name: "List Job", icon: 'fa fa-list' },
        { sideMenu: "Administrator", url: "list-candidate", name: "List Candidate", icon: 'fa fa-users' },
        { sideMenu: "Administrator", url: "list-recruiting-agent", name: "List Recruiting Agents", icon: 'fa fa-list-ul' },
        { sideMenu: "Administrator", url: "company-master", name: "Company Master", icon: 'fa fa-building' },
        { sideMenu: "Administrator", url: "list-invoice", name: "Invoices", icon: 'fa fa-money' },
        { sideMenu: "Administrator", url: "master-data", name: "Master Data", icon: 'fa fa-database' },
      ]
      
      let chooseSidebar = [];
      

    if (loggedInUser?.roles === "Admin") {
      chooseSidebar = Administrator
    }
    else if (loggedInUser?.roles === "Recruitment Agent") {
      chooseSidebar = RecruitingAgent
    }
    else if (loggedInUser?.roles === "Internal Recruiter") {
      chooseSidebar = InternalTeam
    }
    else if (loggedInUser?.roles === "Accountant") {
      chooseSidebar = Accountant
    }
    else if (loggedInUser?.roles === "Key Account Manager") {
      chooseSidebar = KeyAccountManager
    }

    return (
      <>
        <div className="deznav">
          <PerfectScrollbar className="deznav-scroll">
            <MM className="metismenu" id="menu">
              {chooseSidebar &&
                chooseSidebar.map((sidebar) => (
                  <li className={`${path === sidebar.url ? "mm-active hover-toltip" : "hover-toltip"}`}>
                    <Tooltip style={{ display: 'none !important' }}
                      show={true}
                      animation="slideUpDown"
                      position="right center"
                    >
                      <span>{sidebar.name}</span>
                    </Tooltip>
                    <Link to={`/${sidebar.url}`} className="ai-icon" aria-expanded="false">
                      {/* <i className={sidebar.icon}></i> */}
                      <i className={sidebar.icon}>
                      </i>
                      <span className="nav-text">{sidebar.name}
                      </span>
                    </Link>
                  </li>
                )
                )}
            </MM>
          </PerfectScrollbar>
        </div >
      </>
    );
  }
}

export default SideBar;